import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-person-2",
  "use": "icon-si-glyph-person-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-person-2\" id=\"icon-si-glyph-person-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>867</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\">\n            <path d=\"M11.564,9.004 C10.717,10.159 7.905,10.454 7.905,10.454 C7.905,10.454 5.029,10.17 4.182,9.028 C0.122,9.028 0,14.933 0,14.933 L15.808,14.933 C15.808,14.934 16.127,9.004 11.564,9.004 L11.564,9.004 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M10.818,3.02 C10.818,4.689 9.515,7.877 7.91,7.877 C6.303,7.877 5,4.689 5,3.02 C5,1.353 6.303,0 7.91,0 C9.515,0.001 10.818,1.353 10.818,3.02 L10.818,3.02 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-person-2.svg
// module id = nIEe
// module chunks = 62